import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';
import { AuthSession } from '@features/shared/auth/domain/models/auth-session.model';
import { AuthMapper } from '@features/shared/auth/data/mappers/auth.mapper';
import { DeveloperOrganization } from '../../domain/models/developer-organization.model';
import { IDeveloperContextRepository } from '../../domain/repositories/developer-context.repository';
import { DeveloperContextRemoteDatasource } from '../datasources/remote/developer-context.remote-datasource';
import { DeveloperOrganizationMapper } from '../mappers/developer-organization.mapper';

@Injectable()
export class DeveloperContextRepositoryImpl implements IDeveloperContextRepository {
  private readonly datasource = inject(DeveloperContextRemoteDatasource);
  private readonly mapper = inject(DeveloperOrganizationMapper);
  // Reused rather than duplicated, exactly as `StaffClinicsRepositoryImpl` does: the switch answers
  // with the same `TokenResponseDto` a login does.
  private readonly authMapper = inject(AuthMapper);

  public listOrganizations(): Observable<readonly DeveloperOrganization[]> {
    return this.datasource.listOrganizations().pipe(
      map((dtos) => dtos.map((dto) => this.mapper.toDeveloperOrganization(dto))),
    );
  }

  public switchOrganization(
    organizationId: number,
    departmentId: number | null,
    refreshToken: string,
  ): Observable<AuthSession> {
    return this.datasource.switchOrganization(organizationId, departmentId, refreshToken).pipe(
      map((dto) => this.authMapper.toSession(dto)),
    );
  }
}
